import { SVGProps } from "react";

export function OutlineCantEditNote(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="25px"
      height="25px"
      {...props}
    >
      <path
        fill="gray"
        d="M3 10h11v2H3zm0-2h11V6H3zm0 8h7v-2H3zm15.01-3.13l.71-.71a.996.996 0 0 1 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71zm-.71.71l-5.3 5.3V21h2.12l5.3-5.3z"
      ></path>
      <line
        x1="4"
        y1="4"
        x2="20"
        y2="20"
        stroke="gray"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
